import dayjs from 'dayjs';
import type {DateTimeValue, Variant} from './types';

export const formatTime = (
  date?: DateTimeValue,
  variant: Variant = 'short',
): string => {
  return dayjs(date).format(variant === 'long' ? 'LTS' : 'LT');
};
